import * as React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { SimpleProduct, UnitOfMeasureConversion } from '@msdyn365-commerce/retail-proxy';
import { Modal, ModalBody } from '@msdyn365-commerce-modules/utilities';
import { getConversionText } from '../shared-utils/unit-conversion-utils';

export interface IUnitConversionDetailsProps {
    enabled: boolean;
    isOpen: boolean;
    toggle: () => void;
    context: ICoreContext;
    productName: string | undefined;
    productUOM: string | undefined;
    unitConversions: UnitOfMeasureConversion[];
    simpleProduct: SimpleProduct | undefined;
    breakoff: boolean | undefined;
}

const UnitConversionDetails: React.FC<IUnitConversionDetailsProps> = (props: IUnitConversionDetailsProps) => {
    const {
        enabled,
        isOpen,
        toggle,
        context,
        productName,
        productUOM,
        unitConversions,
        simpleProduct,
        breakoff
    } = props;

    if (!enabled || !isOpen) {
        return null;
    }

    return (
        <Modal className='unit-conversion-details' isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <div>
                        <h3>{productName}</h3>
                        <h4>
                            {getConversionText(context, productUOM, unitConversions, simpleProduct, !!breakoff)}
                        </h4>
                    </div>
                    <div>
                        <span>Salgsenhet: </span>
                        <span>{productUOM}</span>
                    </div>
                    <div>
                        <span>Multiple: </span>
                        <span>{simpleProduct?.Behavior?.MultipleOfQuantity}</span>
                    </div>
                    <div>
                        <div>Enhetsomregninger:</div>
                        <textarea
                            aria-label='Enhetsomregninger'
                            readOnly
                            rows={40}
                            style={{ width: '100%', resize: 'none', fontFamily: 'monospace' }}
                            value={(() => {
                                const arr = unitConversions || [];
                                const seen = new Set<string>();
                                const deduped = arr.filter((obj) => {
                                    const str = JSON.stringify(obj);
                                    if (seen.has(str)) {
                                        return false;
                                    }
                                    seen.add(str);
                                    return true;
                                });
                                return JSON.stringify(deduped, null, 2);
                            })()}
                        />
                    </div>
                    <button onClick={() => console.log(productName, JSON.parse(JSON.stringify(unitConversions || [])))}>
                        Print Enhetsomregninger til konsole
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default UnitConversionDetails;
